import { melonReviews } from "@/mocks/kanliao";

function StageStepper({ current, stages }: { current: number; stages: string[] }) {
  return (
    <div className="flex items-center">
      {stages.map((s, i) => {
        const filled = i <= current;
        const isCur = i === current;
        return (
          <div key={s} className="flex items-center">
            {i > 0 && <span className={`h-px w-4 md:w-6 ${filled ? "bg-accent-500" : "bg-background-200"}`}></span>}
            <span
              className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                isCur
                  ? "bg-accent-500 text-foreground-950"
                  : filled
                    ? "bg-accent-100 text-accent-900"
                    : "bg-background-100 text-secondary-500"
              }`}
            >
              {s}
            </span>
          </div>
        );
      })}
    </div>
  );
}

export default function MelonReview() {
  return (
    <section id="review" className="scroll-mt-24 bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.24em] text-accent-400">
            <i className="ri-award-fill" aria-hidden="true"></i>
            热门大瓜盘点
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-background-50 md:text-3xl">
            一颗瓜的一生：从起爆到收束
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-300 md:text-base">
            我们把近期讨论度最高的大瓜摊开来复盘：起爆的引爆点、发酵的节点与目前的进展阶段，一次看清一整条吃瓜时间线。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {melonReviews.map((m) => (
            <article key={m.id} className="flex flex-col overflow-hidden rounded-2xl bg-background-100">
              <div className="relative overflow-hidden">
                <img
                  src={m.image}
                  alt={`看料网 热门大瓜盘点 ${m.name}`}
                  className="h-44 w-full object-cover object-center md:h-52"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-semibold text-foreground-950 backdrop-blur">
                  {m.subject}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2.5 py-1 text-[11px] font-semibold text-accent-300 backdrop-blur">
                  <i className="ri-discuss-fill text-xs" aria-hidden="true"></i>
                  {m.heat}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{m.name}</h3>
                <p className="mt-1 text-sm leading-relaxed text-secondary-700">{m.tagline}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {m.parties.map((p) => (
                    <span key={p} className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-800">
                      {p}
                    </span>
                  ))}
                </div>
                <div className="mt-auto pt-4">
                  <div className="mb-2 flex items-center justify-between">
                    <span className="text-[11px] font-semibold uppercase tracking-wider text-secondary-600">进展阶段</span>
                    <span className="flex items-center gap-1 text-[11px] font-bold text-accent-700">
                      <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                      当前 · {m.stageName}
                    </span>
                  </div>
                  <StageStepper current={m.stage} stages={m.stages} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}